/**
 * The Rush spares feature (M8 plan MC-h4a; RD7(d)): registers `rushSpares.sell` on the craft hook (`craft/hook.ts`),
 * so `UiActions.craft` sells whole Rush spares from the hold to the docked Holdfast market station
 * (`career/rushSpares.ts sellRushSpares`). A career mint; no strategic trade, so the handler never touches
 * `ctx.market`. The Market's goods section shows the sell row (`ui/models/market.ts rushSparesRow`); no station tab.
 */
import { FEATURE_ORDER, type GameFeature } from '../../app/feature'
import { registerCraftHandler, type CraftCommandMap, type CraftHandler } from '../../craft/hook'
import { RUSH_SPARES, sellRushSpares } from '../../career/rushSpares'
import type { CmdOutcome } from '../../ui/contracts'

/** After the career runtime (the registry is global, so the order only places it in the list). */
const ORDER = FEATURE_ORDER.career + 1

/** The handler (exported for the tests; the feature registers it): only at the docked station. */
export const sellHandler: CraftHandler<CraftCommandMap['rushSpares.sell']> = (cmd, ctx): CmdOutcome => {
  const here = ctx.station
  if (here === null || here.id !== cmd.stationId) {
    return ctx.refuse({ code: 'serviceUnavailable', message: RUSH_SPARES.text.notDocked, detail: { station: cmd.stationId } })
  }
  const r = sellRushSpares(ctx.career(), ctx.data, here, cmd.qty)
  if (!r.ok) return ctx.refuse(r.error)
  ctx.commit(r.value, r.effects)
  return ctx.done()
}

let unregister: (() => void) | null = null

const feature: GameFeature = {
  name: 'rushSpares',
  order: ORDER,
  init(): void {
    unregister?.()
    unregister = registerCraftHandler('rushSpares.sell', sellHandler)
  },
  dispose(): void {
    unregister?.()
    unregister = null
  },
}

export default feature
